import React, { useState } from "react";
import "./PrivacyPolicy.css";

const sections = [
  {
    title: "1. A Note From Us",
    content: `At VedAgya, we believe astrology should bring clarity — not confusion.
Your birth details are personal. Your questions are personal.
And your trust matters deeply to us.

This Privacy Policy explains, in simple words, what we collect, why we collect it, and how we protect it.
No hidden tricks. No complicated language.`,
  },
  {
    title: "2. What Information We Collect",
    content: `To generate your birth chart and insights, we need:
• Your Name
• Date of Birth
• Time of Birth
• Place of Birth
• Phone number (for OTP login)
• Email (optional)

We also automatically collect:
• Device type
• App version
• Basic usage data

We do NOT collect:
• Bank passwords
• Aadhaar or PAN (unless legally required)
• Biometric data
• Personal photos (unless voluntarily uploaded)`,
  },
  {
    title: "3. Why We Collect This Information",
    content: `We use your data only to:
• Generate accurate astrological charts
• Provide structured insights
• Securely log you into your account
• Improve the app experience
• Respond to support requests

We do not use your birth data to manipulate you or create fear-based messaging.`,
  },
  {
    title: "4. How We Protect Your Data",
    content: `We take security seriously.

Your data is:
• Encrypted during transmission
• Stored securely in protected servers
• Accessed only by authorized systems

We use OTP login so you don’t need to remember passwords.`,
  },
  {
    title: "5. Do We Share Your Data?",
    content: `No, we do not sell your data.

We may share limited technical data with:
• Cloud hosting providers
• Analytics services (anonymized only)

We may share data only when required by law.`,
  },
  {
    title: "6. AI & Insights",
    content: `VedAgya uses technology to explain astrological combinations.

But:
• The app does not make decisions for you.
• It does not replace medical, legal, or financial advice.

It is a guidance tool — not a prophecy machine.`,
  },
  {
    title: "7. Your Rights",
    content: `You can:
• Request your data
• Correct your details
• Ask for account deletion
• Withdraw consent

Email us at: Mail@vedagya.in`,
  },
  {
    title: "8. Data Retention",
    content: `We keep your data:
• As long as your account is active
• Until you request deletion
• As required by law`,
  },
  {
    title: "9. Children’s Privacy",
    content: `VedAgya is for users above 18.
We do not knowingly collect data from minors.`,
  },
  {
    title: "10. Updates to This Policy",
    content: `If we make changes, we will:
• Update the “Last Updated” date
• Notify users inside the app if required`,
  },
  {
    title: "11. Contact Us",
    content: `Email: mail@vedagya.in
Company: Trikaal Darshi Technologies Private Limited (VedAgya)
Location: India`,
  },
  {
    title: "Final Note",
    content: `VedAgya offers structured insights — not certainty.
Your life decisions are your own.
Your data remains yours.`,
  },
];

const PrivacyPolicy = () => {
  const [openIndex, setOpenIndex] = useState(null);

  return (
    <div className="policy-wrapper">

      {/* Rotating Background Logo */}
      <div className="rotating-logo-layer">
        <img
          src="/assets/vedagya_logo_white.png"
          alt="VedAgya Logo"
          className="rotating-logo"
        />
      </div>

      <div className="policy-container">
        <h1 className="policy-title">Privacy Policies of <br /> VedAgya</h1>

        {sections.map((sec, index) => (
          <div key={index} className="policy-section">
            <div
              className="policy-header"
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
            >
              <h3>{sec.title}</h3>
              <span className={`arrow ${openIndex === index ? "open" : ""}`}>▼</span>
            </div>

            <div
              className={`policy-content ${
                openIndex === index ? "expanded" : ""
              }`}
            >
              <p>{sec.content}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PrivacyPolicy;
